import React from "react";
import NavBar from "../components/NavBar";
import HeroImg from "../components/HeroImg";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div>
      <NavBar />
      <HeroImg />
      <Footer />
    </div>
  );
};

export default Home;
